/**
 * CWSカテゴリ変換マスタ設定画面Input用VOクラス
 */
export class KYMW6801InputModel {

  /**
   * 処理区分(0：登録)
   */
  public static PROCES_DIV_REGIST: string = <string>'0';
  /**
   * 処理区分(1：更新)
   */
  public static PROCES_DIV_UPDATE: string = <string>'1';

  /**
   * 処理区分
   */
  public procesDiv: string = <string>'';
  /**
   * カテゴリ区分
   */
  public categoryDiv: string = <string>'';
  /**
   * カテゴリコード
   */
  public categoryCode: string = <string>'';
  /**
   * カテゴリ変換ID
   */
  public categoryConvID: string = <string>'';
}